export const stars = [
  {
    id: 's1',
    name: '沈亦辰',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20young%20confident%20male%20celebrity%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20subtle%20red%20rim%20light%2C%20dramatic%20moody%20lighting%2C%20minimal%20modern%20magazine%20aesthetic%2C%20sharp%20high%20detail%2C%20cinematic%20composition&width=400&height=400&seq=star-s1&orientation=squarish',
    title: '顶流男演员',
    bio: '出道近十年，凭借多部现象级剧集跻身顶流，人气与话题度长期居高不下，是娱乐圈最受关注的男演员之一。',
    tags: ['顶流', '演员', '话题王'],
    followers: '3280万',
    heat: 98,
  },
  {
    id: 's2',
    name: '林晚晴',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20an%20elegant%20young%20female%20celebrity%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20soft%20red%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20fashion%20magazine%20aesthetic%2C%20high%20detail%2C%20graceful%20composition&width=400&height=400&seq=star-s2&orientation=squarish',
    title: '当红小花',
    bio: '近年迅速走红的年轻女演员，被媒体称为"收视保障"，新剧接连定档，商业价值持续攀升。',
    tags: ['小花', '演员', '新剧'],
    followers: '2150万',
    heat: 92,
  },
  {
    id: 's3',
    name: '苏以宁',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20mature%20elegant%20Asian%20actress%20against%20a%20deep%20charcoal%20studio%20background%20with%20warm%20amber%20accent%20light%2C%20dramatic%20theatrical%20lighting%2C%20refined%20minimal%20aesthetic%2C%20high%20detail%2C%20sophisticated%20composition&width=400&height=400&seq=star-s3&orientation=squarish',
    title: '实力派影后',
    bio: '三度斩获影视大奖的实力派女演员，作品口碑稳定，被业内公认为"演技派标杆"。',
    tags: ['影后', '实力派'],
    followers: '1890万',
    heat: 88,
  },
  {
    id: 's4',
    name: '陆景珩',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20stylish%20young%20male%20pop%20idol%20against%20a%20dark%20charcoal%20background%20with%20vibrant%20red%20and%20amber%20accent%20lights%2C%20dramatic%20concert%20style%20lighting%2C%20modern%20minimal%20poster%20aesthetic%2C%20high%20detail&width=400&height=400&seq=star-s4&orientation=squarish',
    title: '偶像歌手',
    bio: '从偶像团体单飞后人气不减，个人巡演场场售罄，是当下最具票房号召力的新生代歌手。',
    tags: ['偶像', '歌手', '巡演'],
    followers: '2470万',
    heat: 90,
  },
  {
    id: 's5',
    name: '顾清欢',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20trendy%20young%20female%20singer%20against%20a%20dark%20charcoal%20studio%20background%20with%20soft%20pink%20and%20red%20rim%20lights%2C%20dramatic%20fashion%20lighting%2C%20minimal%20modern%20aesthetic%2C%20high%20detail&width=400&height=400&seq=star-s5&orientation=squarish',
    title: '女团前成员',
    bio: '原人气女团成员，退团后转型独立音乐人，风格大胆转变，一举一动都牵动着粉丝的关注。',
    tags: ['女团', 'solo', '转型'],
    followers: '1130万',
    heat: 76,
  },
  {
    id: 's6',
    name: '江砚',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20calm%20mature%20male%20actor%20against%20a%20deep%20charcoal%20studio%20background%20with%20a%20single%20warm%20key%20light%2C%20low%20key%20dramatic%20lighting%2C%20refined%20minimal%20magazine%20aesthetic%2C%20high%20detail%2C%20thoughtful%20mood&width=400&height=400&seq=star-s6&orientation=squarish',
    title: '低调影帝',
    bio: '以低调著称的影帝级演员，作品产量不高却部部精品，鲜少参加综艺与商业活动。',
    tags: ['影帝', '低调', '实力'],
    followers: '980万',
    heat: 81,
  },
  {
    id: 's7',
    name: '温知夏',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20cheerful%20young%20female%20variety%20show%20host%20against%20a%20dark%20charcoal%20studio%20background%20with%20bright%20amber%20accent%20light%2C%20dramatic%20studio%20lighting%2C%20modern%20minimal%20poster%20aesthetic%2C%20high%20detail&width=400&height=400&seq=star-s7&orientation=squarish',
    title: '综艺常驻嘉宾',
    bio: '多档热门综艺的常驻嘉宾，以幽默直率圈粉无数，被网友称为"综艺开心果"。',
    tags: ['综艺', '人气', '主持'],
    followers: '1520万',
    heat: 79,
  },
  {
    id: 's8',
    name: '霍沉',
    avatar: 'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20determined%20young%20male%20rising%20actor%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20cool%20red%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20aesthetic%2C%20high%20detail&width=400&height=400&seq=star-s8&orientation=squarish',
    title: '新锐青年演员',
    bio: '凭借一部小成本剧集一夜成名的新锐演员，被誉为"最有潜力的新生代面孔"。',
    tags: ['新锐', '演员', '潜力'],
    followers: '760万',
    heat: 70,
  },
];